import styled from 'styled-components';
import { zIndex } from 'tokens';

export const PanelWrapper = styled.div<{ $overlay?: boolean; $visible?: boolean }>`
	${({ $overlay, $visible }) =>
		$overlay
			? `
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: ${zIndex.panelOverlay};
		box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);
		transform: translateX(${$visible ? '0' : '-100%'});
		transition: transform 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);
		pointer-events: ${$visible ? 'auto' : 'none'};
	`
			: `
		grid-area: left-panel;
		z-index: ${zIndex.panel};
	`}
	display: flex;
	flex-direction: column;
`;

export const ScrollingArea = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: thin;
	&::-webkit-scrollbar {
		width: 8px;
	}
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
`;

export const Entries = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 8px;
`;

export const ReferenceFrames = styled.div`
	margin: 0 12px;

	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	padding-top: 12px;
	padding-bottom: 8px;
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
	height: 100%;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 20px;
	max-width: 280px;
`;
